import { denormalizeCollection } from "../shared/normalizeCollection";

export const getCategories = ({ categories }) => categories;

export const getCategoriesList = ({ categories }) =>
  denormalizeCollection(categories);
